import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';

import TreeList from 'components/TreeList';

import withAppStore from 'decorators/withAppStore';

@withAppStore
@observer
export default class Tree extends Component {

  _cachedStore = null;

  @computed get store() {
    return this.appStore.treeStore;
  }

  @computed get rootLevelNodes() {
    return this.store.nodes.filter(node => node.parentId === 0);
  }

  componentWillMount() {
    this._cachedStore = this.store;
    this.store.reload();
  }

  componentWillUpdate() {
    if (this.store !== this._cachedStore) {
      this._cachedStore = this.store;
      this.store.reload();
    }
  }

  render() {
    return <TreeList nodes={ this.rootLevelNodes } />;
  }

}



// WEBPACK FOOTER //
// ./src/components/Tree.js